import errors from './errors.js';
import translation from './translation/index.js';
const trTR = Object.freeze({
    translation,
    errors,
});
export default trTR;
